<template>
  <div class="dashboard">
    <Loading v-if="pageLoading" />
    <OrderDetailsOnDashboard
      :orderDetails="showThisOrder"
      v-if="toggleOrderDetailsOnDashboard"
      @close-order-details-dashboard="showOrderDetailsOnDashboard"
    />
    <div class="header" v-if="!pageLoading">
      <div class="user-greeting">
        <p>Dashboard!</p>
        <p>
          {{ this.greeting }}
          {{
            this.$store.state.profileFirstName
              ? this.$store.state.profileFirstName
              : "User"
          }}!
        </p>
      </div>
      <div class="quick-access-links">
        <button class="order-placed-button" @click.prevent="goToOrderSummary">
          Track A Placed Order
        </button>
        <button class="saving-a-saviour-button" @click.prevent="goToTask">
          I Was Saving Savour!
        </button>
        <button
          v-if="isUserAdmin"
          @click.prevent="goToAdmin"
          class="user-admin-button"
        >
          Admin
        </button>
      </div>
    </div>
    <div class="dashboard-content" v-if="!pageLoading">
      <div class="previous-order-and-cart-items">
        <div class="previous-orders">
          <h2>Your Recent Orders</h2>
          <div class="no-orders" v-if="noOrdersToShow">
            How About We Help You Place Your First Order?
            <br />
            <router-link class="link" :to="{ name: 'OrderNow' }"
              >This Way To View The Restaurants!
            </router-link>
          </div>
          <div class="orders" v-else>
            <OrderViewDashboard
              @see-order="showOrderDetailsOnDashboard"
              :key="index"
              v-for="index in arrayIndexesForOrderDetail"
              :orderDetails="orderDetails[index]"
            />
          </div>
        </div>
        <div class="cart-status">
          <h2>Your Cart</h2>
          <div class="cart-empty" v-if="cartIsEmpty">
            Cart Is Empty!
            <br />
            Let's Add Something!
            <br />
            <router-link class="link" :to="{ name: 'OrderNow' }"
              >This Way To View The Restaurants!
            </router-link>
          </div>
          <div class="cart-content" v-else>
            <div class="cart-items">
              <OrderSummaryItemView
                :key="item"
                v-for="item in arrayIndexesForItemView"
                :itemName="cart[item]"
                :itemValue="cart[item + 1]"
                :itemQuantity="cart[item + 2]"
              />
            </div>
            <div class="cart-footer">
              <button @click.prevent="goToCart">Let's Checkout!</button>
            </div>
          </div>
        </div>
      </div>
      <div class="your-saves">
        <h2>Your Saves</h2>
        <div class="no-saves" v-if="noSaves">
          <p>You Have Not Saved Anyone Yet!</p>
          <router-link class="link" :to="{ name: 'Saviour' }">
            Want To Save? Follow Me!</router-link
          >
        </div>
        <div class="saves" v-else>
          <OrderDeliveredDashboard
            v-for="index in arrayIndexesForOrderDelivered"
            :key="index"
            :orderDeliveredDetails="ordersDeliveredDetails[index]"
          />
        </div>
      </div>
    </div>

    <!--
      <br />
    <div class="taskbar">
      <div class="child"><button @click="goToTask">View Task</button></div>
    </div>
    -->

    <!-- <Coordinate /> -->
  </div>
</template>

<script>
import OrderSummaryItemView from "../components/OrderSummaryItemView.vue";
import OrderViewDashboard from "../components/OrderViewDashboard.vue";
import Loading from "../components/Loading.vue";
import OrderDeliveredDashboard from "../components/OrderDeliveredDashboard.vue";
import OrderDetailsOnDashboard from "../components/OrderDetailsOnDashboard.vue";
import db from "../firebase/firebaseInit";
import firebase from "firebase/app";

export default {
  name: "Dashboard",
  components: {
    OrderSummaryItemView,
    OrderViewDashboard,
    Loading,
    OrderDeliveredDashboard,
    OrderDetailsOnDashboard,
  },
  data() {
    return {
      date: new Date(),
      greeting: null,
      noOrdersToShow: true,
      cartIsEmpty: true,
      pageLoading: false,
      noSaves: true,
      cart: [],
      ordersId: [],
      arrayIndexesForItemView: [],
      orderDetails: [],
      arrayIndexesForOrderDetail: [],
      ordersDeliveredId: [],
      ordersDeliveredDetails: [],
      arrayIndexesForOrderDelivered: [],
      toggleOrderDetailsOnDashboard: false,
      showThisOrder: null,
      isUserAdmin: false,
    };
  },
  async mounted() {
    // This is for the greeting bit.
    this.pageLoading = true;
    const hour = this.date.getHours();
    console.log(hour);
    if (hour >= 3 && hour < 12) {
      this.greeting = "Good Morning";
    } else if (hour >= 12 && hour < 5) {
      this.greeting = "Good Afternoon";
    } else {
      this.greeting = "Good Evening";
    }

    const dataBase = await db
      .collection("users")
      .doc(firebase.auth().currentUser.uid);
    const dbResults = await dataBase.get();

    this.cart = dbResults.data().cart;
    this.ordersId = dbResults.data().orders;
    this.ordersDeliveredId = dbResults.data().ordersDelivered;

    // Checking Cart
    if (!this.cart || this.cart.length === 0) {
      this.cartIsEmpty = true;
    } else {
      this.cartIsEmpty = false;
    }

    //this.pageLoading = false;

    // Checking Orders Delivered
    if (!this.ordersDeliveredId || this.ordersDeliveredId.length === 0) {
      this.noSaves = true;
    } else {
      this.noSaves = false;
      for (
        let i = 0;
        i <
        (this.ordersDeliveredId.length >= 5
          ? 5
          : this.ordersDeliveredId.length);
        i++
      ) {
        const dataBase = await db
          .collection("orders")
          .doc(this.ordersDeliveredId[this.ordersDeliveredId.length - 1 - i]);
        const dbResults = await dataBase.get();

        const orderDeliveredDetail = {
          restaurantName: dbResults.data().restaurantName,
          userName: dbResults.data().userName,
          date: dbResults.data().orderTime,
          totalPrice: dbResults.data().totalPrice,
          saviourPerk: dbResults.data().saviourPerk,
        };

        this.ordersDeliveredDetails.push(orderDeliveredDetail);

        this.arrayIndexesForOrderDelivered.push(i);
      }
    }

    this.pageLoading = false;

    // Checking Users Orders
    if (!this.ordersId || this.ordersId.length === 0) {
      this.noOrdersToShow = true;
    } else {
      this.noOrdersToShow = false;
      for (
        let i = this.ordersId.length - 5 < 0 ? 0 : this.ordersId.length - 5;
        i < this.ordersId.length;
        i++
      ) {
        const dataBase = await db.collection("orders").doc(this.ordersId[i]);
        const dbResults = await dataBase.get();

        const orderDetail = {
          restaurantName: dbResults.data().restaurantName,
          restaurantLocation: dbResults.data().restaurantLocation,
          orderTime: dbResults.data().orderTime,
          totalPrice: dbResults.data().totalPrice,
          cancelled: dbResults.data().cancelled,
          delivered: dbResults.data().delivered,
          acceptedBySaviour: dbResults.data().acceptedBySaviour,
          cart: dbResults.data().cart,
          deliveryLocation: dbResults.data().userLocation,
          saviourName: dbResults.data().saviourName,
          saviourContact: dbResults.data().saviourContact,
        };
        //console.log(orderDetail);
        this.orderDetails.push(orderDetail);
        this.arrayIndexesForOrderDetail.push(
          this.arrayIndexesForOrderDetail.length
        );
      }
      this.arrayIndexesForOrderDetail.reverse();
    }

    for (let i = 1; i < this.cart.length; i += 3) {
      this.arrayIndexesForItemView.push(i);
    }

    this.isUserAdmin = this.$store.state.profileAdminStatus;

    this.pageLoading = false;
  },
  computed: {
    /*
    getGreeting() {
      const hour = this.date.getHours();
      if (hour >= 18 && hour < 3) {
        //this.greeting = `Good Evening ${this.$store.state.profileFirstName} ${this.$store.state.profileLastName}!`
        return "Good Evening";
      } else if (hour >= 3 && hour < 12) {
        return "Good Morning";
      } else {
        return "Good Afternoon";
      }
    },
    */
  },
  methods: {
    /*
    getGreeting() {
      const hour = this.date.getHours();
      if (hour >= 18 && hour < 3) {
        //this.greeting = `Good Evening ${this.$store.state.profileFirstName} ${this.$store.state.profileLastName}!`
        this.greeting = "Good Evning";
      } else if (hour >= 3 && hour < 12) {
        this.greeting = "Good Morning";
      } else {
        this.greeting = "Good Afternoon";
      }
    },
    */
    showOrderDetailsOnDashboard(orderDetails) {
      this.toggleOrderDetailsOnDashboard = !this.toggleOrderDetailsOnDashboard;
      this.showThisOrder = orderDetails;
      console.log(orderDetails);
    },
    goToAdmin() {
      this.$router.push({
        name: "AdminView",
      });
    },
    goToOrderSummary() {
      this.$router.push({
        name: "OrderSummary",
      });
    },
    goToCart() {
      this.$router.push({
        name: "Cart",
      });
    },
    goToTask() {
      this.$router.push({
        name: "Tasks",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  .header {
    border-bottom: 2px solid #000;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;

    .user-greeting {
      flex-basis: 90%;
    }

    .quick-access-links {
      flex-basis: 10%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      flex-direction: column;

      @media (min-width: 800px) {
        flex-direction: row;
        justify-content: space-evenly;
      }

      .order-placed-button {
        width: 60vw;
        cursor: pointer;

        @media (min-width: 800px) {
          //15vw
          width: 30vw;
        }
      }

      .saving-a-saviour-button {
        width: 60vw;
        cursor: pointer;

        @media (min-width: 800px) {
          //15vw
          width: 30vw;
        }
      }

      .user-admin-button {
        width: 60vw;
        cursor: pointer;

        @media (min-width: 800px) {
          //15vw
          width: 30vw;
        }
      }
    }

    p {
      margin-top: 20px;
      text-align: center;
      font-size: 40px;
    }
  }

  .dashboard-content {
    display: flex;
    flex-direction: column;

    h2 {
      padding: 10px 0;
      text-align: center;
    }

    .previous-order-and-cart-items {
      flex-basis: 50%;
      display: flex;
      flex-direction: column;
      min-height: 60vh;
      margin-bottom: 10px;
      //background-image: url("../assets/background/background21.jpg");

      @media (min-width: 800px) {
        flex-direction: row;
      }

      .previous-orders {
        //border: 1px solid blue;
        //margin-bottom: 5px;
        flex-basis: 50%;
        border-radius: 8px;
        margin: 0 5px 5px 5px;
        background-color: #f1f1f1;
        min-height: 60vh;
        padding: 0 10px;

        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
          0 2px 4px -1px rgba(0, 0, 0, 0.6);

        @media (min-width: 800px) {
          //margin-right: 5px;
          //margin-bottom: 0;
          margin: 0 5px;
          flex-basis: 65%;
        }

        .link {
          text-transform: none;
        }

        .no-orders {
          padding-top: 120px;
          text-align: center;
        }
      }

      .cart-status {
        flex-basis: 50%;
        //border: 1px solid red;
        border-radius: 8px;
        //margin-top: 5px;
        margin: 5px 5px 0 5px;
        //background-color: #f1f1f1;
        background: rgba(0, 0, 0, 0.5);
        min-height: 50vh;
        //max-height: 50vh;
        //overflow: auto;

        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
          0 2px 4px -1px rgba(0, 0, 0, 0.6);

        @media (min-width: 800px) {
          //margin-left: 5px;
          //margin-top: 0;
          margin: 0 5px;
          flex-basis: 35%;
        }

        .link {
          text-transform: none;
          color: #fff;
        }

        h2 {
          color: #fff;
        }

        .cart-content {
          display: flex;
          flex-direction: column;

          .cart-items {
            padding: 0 12px;
            overflow: auto;
            flex-basis: 95%;
            max-height: 36vh;
            //border-bottom: 1px solid black;
          }

          .cart-footer {
            flex-basis: 5%;
            display: flex;
            justify-content: center;

            button {
              &:hover {
                cursor: pointer;
              }
            }
          }
        }

        .cart-empty {
          color: #fff;
          padding-top: 120px;
          text-align: center;
        }
      }
    }

    .your-saves {
      flex-basis: 50%;
      //min-height: 100px;
      border: 1px solid black;
      padding: 0 10px;
      margin: 5px 5px;
      border-radius: 8px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.6);

      .link {
        text-transform: none;
      }

      .no-saves {
        padding: 120px 0;
        text-align: center;
      }
    }
  }
}

.taskbar {
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 50%;
  padding: 10px;
  position: relative;
  min-height: 100px;

  .child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
